import TitleBar7 from './titleBar7';
export default TitleBar7;
